// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_9l6tcR"};